const formValidationUtils = {
  isInputEmpty: (input: string) => input.trim().length === 0,
};

export default formValidationUtils;
